import { REACT_APP__URL_STORAGE_STATIC } from "@smp/utils";

import { fontsList } from "./fonts";
import { IFont } from "./fonts/fonts.types";
import { IFontName } from "./load_fonts.types";

const createFontFacePromise = (font: IFont, fontName: IFontName) => {
  const fontUrl = font.urlSet
    .map(
      (fontUrlSet) =>
        `url("${REACT_APP__URL_STORAGE_STATIC}${fontUrlSet.url}") format("${fontUrlSet.format}")`,
    )
    .join(", ");

  return new FontFace(fontName, fontUrl, {
    style: font.style,
    weight: font.weight,
  })
    .load()
    .then((fontLoaded) => document.fonts.add(fontLoaded));
};

export const loadFonts = (
  fontNames: IFontName[],
): Promise<PromiseSettledResult<FontFaceSet>[]> => {
  if (typeof window === "undefined") {
    return Promise.resolve([]);
  }

  const fontFacesPromisesList = fontNames.reduce(
    (
      fontFacesPromisesListAccumulator: Promise<FontFaceSet>[],
      fontName: IFontName,
    ) => {
      const currentFontFontFacesPromisesList = fontsList[fontName].map((font) =>
        createFontFacePromise(font, fontName),
      );

      return [
        ...fontFacesPromisesListAccumulator,
        ...currentFontFontFacesPromisesList,
      ];
    },
    [],
  );

  return Promise.allSettled(fontFacesPromisesList);
};
